import * as React from "react";
import { Container, Paper } from "@material-ui/core";
import { useState } from "react";
import RogueFilter from "./RogueFilter";
import RogueList from "./RogueList";

const Rogue = props => {
  //useVerifyPermission('customroutes', 'thyprematurefailures.read');

  const now = new Date();
  const [filterParams, setFilterParams] = useState({
    startDate: new Date(new Date().setMonth(now.getMonth() - 1)),
    endDate: now,
  });

  const CreateFilter = filterParams => {
    var filter = {
      createdDate__gte: filterParams.startDate,
      createdDate__lte: filterParams.endDate,
    };

    return filter;
  };

  return (
    <>
      <RogueFilter filterParams={filterParams} setFilterParams={setFilterParams} />
      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <RogueList basePath="reliabilityrogues" filterParams={CreateFilter(filterParams)} {...props} />
        </Paper>
      </Container>
    </>
  );
};

export default Rogue;
